// extracted by mini-css-extract-plugin
export var blue = "_1y-g";
export var brand = "_1y-c";
export var darkGrey = "_1y-f";
export var disabled = "_1y-6";
export var disabledSubtle = "_1y-7";
export var error = "_1y-8";
export var green = "_1y-h";
export var grey = "_1y-e";
export var icon = "_1y-0";
export var inherit = "_1y-b";
export var lightGrey = "_1y-d";
export var orange = "_1y-j";
export var pink = "_1y-l";
export var primary = "_1y-1";
export var purple = "_1y-m";
export var quaternary = "_1y-4";
export var quinary = "_1y-5";
export var red = "_1y-k";
export var secondary = "_1y-2";
export var success = "_1y-a";
export var tertiary = "_1y-3";
export var warning = "_1y-9";
export var white = "_1y-n";
export var yellow = "_1y-i";